/* Blocks the browser's image context menu (Save image as… / Open image
   in new tab) and image dragging, site-wide. Right-clicks on anything
   that is not an image are left alone. A deterrent, not protection —
   the files are still in the page source for anyone who goes looking. */
(() => {
  document.addEventListener('contextmenu', (event) => {
    if (event.target instanceof Element && event.target.closest('img, picture, svg')) {
      event.preventDefault();
    }
  });

  document.addEventListener('dragstart', (event) => {
    if (event.target instanceof Element && event.target.closest('img, picture, svg')) {
      event.preventDefault();
    }
  });
})();
